'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SurflineLogo = require('./SurflineLogo');

var _SurflineLogo2 = _interopRequireDefault(_SurflineLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SurflineLogo2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflineLogo/index.js
// module id = 180
// module chunks = 0